import useSWR from 'swr';

import {
  getUrgentCasesDashboard,
  type GetUrgentCasesDashboardParams,
  type UrgentCasesDashboardResponse,
} from '@/api/urgent-cases';
import { ENDPOINTS } from '@/api/endpoints';
import { StandardResponse } from '@/api/standard-response';
import { isDevEnv } from '@/libs/dev-logs';

type Key = [string, GetUrgentCasesDashboardParams | undefined];

export function useGetUrgentCasesDashboard(params?: GetUrgentCasesDashboardParams) {
  const { data, error, isLoading, mutate } = useSWR<
    StandardResponse<UrgentCasesDashboardResponse>,
    Error,
    Key
  >([ENDPOINTS.URGENT_CASES_DASHBOARD, params], ([, p]: Key) => getUrgentCasesDashboard(p), {
    errorRetryCount: 1,
    revalidateOnFocus: !isDevEnv(),
    refreshInterval: 30000,
  });

  return {
    dashboard: data?.data,
    loading: isLoading,
    error,
    mutate,
  };
}
